const MTR_TEMPLATE_FIELD_LABELS = {
  mtrStructMainId: '主分類',
  mtrStructSubId: '次分類',
  code: '代號',
  name: '名稱',
  remark: '備註',
  serialFormatter: '序號格式',
  specs: '規格規則',
};

function resolveMtrTemplateFieldLabel(path) {
  const specMatch = path.match(/^specs\.(\d+)\.mtrSpecId$/);
  if (specMatch) {
    return `規格 #${Number(specMatch[1]) + 1}`;
  }

  const orderMatch = path.match(/^specs\.(\d+)\.displayOrder$/);
  if (orderMatch) {
    return `規格 #${Number(orderMatch[1]) + 1} 排序`;
  }

  return undefined;
}

export {
  MTR_TEMPLATE_FIELD_LABELS,
  resolveMtrTemplateFieldLabel,
};
